import { SubmitBlocker, SubmitEligibilityInput, getSubmitBlockers } from 'services/businessBilling/canSubmit';
import { useCooldown } from './useCooldown';

export interface CanSubmit {
    allowed: boolean;
    blockers: SubmitBlocker[];
}

/**
 * The submit rule, kept correct over time. It is evaluated on every render, so a
 * changed CUI (or any other input) closes the button in the same render. The
 * verification expiry has to close it even when nothing else changes, so one
 * timer is armed for that instant (no polling). The clock is the machine's own;
 * the server re-checks expiry at submit, so skew only affects convenience.
 */
export const useCanSubmit = (input: Omit<SubmitEligibilityInput, 'now'>): CanSubmit => {
    const blockers = getSubmitBlockers({ ...input, now: Date.now() });

    const { lookup } = input;
    const expiresAt = lookup.phase === 'done' && lookup.result?.kind === 'eligible'
        ? Date.parse(lookup.result.response.verification.expiresAt)
        : null;

    // The verification expiry must close the button even when nothing else changes: re-render at that instant.
    useCooldown(expiresAt);

    return { allowed: blockers.length === 0, blockers };
};
